import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import injectSheet from 'react-jss';
import ReactMarkdown from 'react-markdown';

const styles = () => ({
  // '@media (max-width: 992px)': {
  //   title: {
  //     textAlign: 'center',
  //   },
  // },
  root: {
    padding: '3em 0',
  },
  content: {
    paddingTop: '1em',
    'box-sizing': 'content-box',
  },
  text: {
    textAlign: 'justify',
    '& p': {
      marginTop: '10px',
    },
  },
  img: {
    maxWidth: '100%',
    maxHeight: '100%',
  },
});

const PresentationTitleImg = (props) => {
  const { classes, title, text, img } = props;

  return (
    <Row justify="center" type="flex">
      <Col span={18}>
        <Col md={18} xs={24} className={classes.root}>
          <Row className={classes.title}>
            <h1>{title}</h1>
          </Row>
          <Row className={classes.content} type="flex" gutter={24}>
            <Col md={12} xs={20}>
              <img src={img} className={classes.img} alt={img} />
            </Col>
            <Col md={12} xs={20} className={classes.text}>
              <ReactMarkdown source={text} />
            </Col>
          </Row>
        </Col>
      </Col>
    </Row>
  );
};

PresentationTitleImg.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.element.isRequired,
  img: PropTypes.string.isRequired,
};

export default injectSheet(styles)(PresentationTitleImg);



// WEBPACK FOOTER //
// ./src/app/components/presentationTitleImg.jsx